// extracted by mini-css-extract-plugin
export default {"phoneOtpMethodField":"phone-otp-method-selection_phoneOtpMethodField__WCW91"};